import { BaseViewModel } from "./base.view-model";

export class PersonNameViewModel extends BaseViewModel {
    firstName?: string = undefined;
    lastName?: string = undefined;
    middleName?: string = undefined;
    preferredName?: string = undefined;
    prefixName?: string = undefined;
    suffixName?: string = undefined;
}
